import _classCallCheck from "/home/livesetup/Desktop/Blockchain/Dapp/kigali-dex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/livesetup/Desktop/Blockchain/Dapp/kigali-dex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/livesetup/Desktop/Blockchain/Dapp/kigali-dex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/livesetup/Desktop/Blockchain/Dapp/kigali-dex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/livesetup/Desktop/Blockchain/Dapp/kigali-dex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { PureComponent } from 'react';
import './light.css';
import './dark.css';

var Select = /*#__PURE__*/function (_PureComponent) {
  _inherits(Select, _PureComponent);

  function Select(props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).call(this, props));

    _this.tryFoldListener = function (e) {
      if (_this.container && !_this.container.contains(e.target)) {
        _this.setState({
          unfolded: false
        });
      }
    };

    _this.switchFold = function () {
      _this.setState({
        unfolded: !_this.state.unfolded
      });
    };

    _this.setContainer = function (ref) {
      if (!ref) {
        return;
      }

      _this.container = ref;
    };

    _this.renderOption = function (option) {
      return option.component ? option.component : option.text;
    };

    _this.id = Math.random().toString();
    _this.state = {
      unfolded: false
    };
    return _this;
  }

  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.document.addEventListener('mouseup', this.tryFoldListener);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.document.removeEventListener('mouseup', this.tryFoldListener);
    }
  }, {
    key: "getDropdownDirection",
    value: function getDropdownDirection() {
      if (!this.container) {
        return 'down';
      }

      var topDistance = function topDistance(elem) {
        var location = 0;

        if (elem.offsetParent) {
          do {
            location += elem.offsetTop;
            elem = elem.offsetParent;
          } while (elem);
        }

        return location >= 0 ? location : 0;
      };

      var bottomDistance = window.innerHeight - topDistance(this.container) - this.container.offsetHeight;
      return bottomDistance < 200 ? 'up' : 'down';
    }
  }, {
    key: "renderDropdown",
    value: function renderDropdown() {
      var _this2 = this;

      var _this$props = this.props,
          options = _this$props.options,
          onSelect = _this$props.onSelect,
          size = _this$props.size;
      var items = [];

      var _iterator = _createForOfIteratorHelper(options),
          _step;

      try {
        var _loop = function _loop() {
          var option = _step.value;

          if (option.hidden) {
            return "continue";
          }

          items.push(React.createElement("div", {
            key: option.value,
            className: "item ".concat(size === 'small' ? 'small' : '', " ").concat(option.disabled ? 'disabled' : ''),
            onClick: function onClick(e) {
              if (option.disabled) {
                return;
              }

              if (onSelect) {
                onSelect(option, e);
              }

              if (option.onSelect) {
                option.onSelect(option, e);
              }

              _this2.setState({
                unfolded: false
              });
            }
          }, _this2.renderOption(option)));
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ret = _loop();

          if (_ret === "continue") continue;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var dropdownClassNames = ['dropdown'];
      var direction = this.getDropdownDirection();

      if (direction === 'down') {
        dropdownClassNames.push('down');
      } else if (direction === 'up') {
        dropdownClassNames.push('up');
      }

      return React.createElement("div", {
        className: dropdownClassNames.join(' ')
      }, items);
    }
  }, {
    key: "renderSelected",
    value: function renderSelected() {
      var selectOption;
      var _this$props2 = this.props,
          options = _this$props2.options,
          selected = _this$props2.selected,
          formatSelect = _this$props2.formatSelect,
          noCaret = _this$props2.noCaret,
          blank = _this$props2.blank,
          size = _this$props2.size;

      var _iterator2 = _createForOfIteratorHelper(options),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var option = _step2.value;

          if (selected === option.value) {
            selectOption = option;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return React.createElement("div", {
        className: "selected ".concat(size === 'small' ? 'small' : ''),
        onClick: this.switchFold
      }, selectOption ? formatSelect ? formatSelect(selectOption) : this.renderOption(selectOption) : blank, noCaret ? null : this.renderCaret());
    }
  }, {
    key: "renderCaret",
    value: function renderCaret() {
      return React.createElement("div", {
        className: "caret ".concat(this.props.size === 'small' ? 'small' : '')
      });
    }
  }, {
    key: "render",
    value: function render() {
      var unfolded = this.state.unfolded;
      var classNames = ['select'];

      if (unfolded) {
        classNames.push('unfolded');
      }

      var theme = this.props.theme;

      if (theme === 'light') {
        classNames.push('light');
      } else {
        classNames.push('dark');
      }

      return React.createElement("div", {
        className: classNames.join(' '),
        id: this.id,
        ref: this.setContainer
      }, this.renderSelected(), this.renderDropdown());
    }
  }]);

  return Select;
}(PureComponent);

export { Select as default };